import { formatMoney } from "../../utils";
import { Discount, TicketOwner, TicketType } from "../../utils/types";
import { Loading } from "../loading";

export function OrderSummary({
  step,
  selectedTickets,
  totalValues,
  handleBookTickets,
  ticketOwners,
  loading = false,
  primaryTicketOwner,
  handleAddTicketDataToDB,
  handleFetchDiscount,
  discountCode,
  setDiscountCode,
  discountLoading,
  discount,
  setDiscount,
  disableContinueButton,
}: {
  step: number;
  selectedTickets: TicketType[];
  totalValues: {
    total: number;
    discount: number;
    totalQuantity: number;
    charges?: number;
    subtotal?: number;
  };
  handleBookTickets: () => void;
  ticketOwners: TicketOwner[];
  loading: boolean;
  primaryTicketOwner: TicketOwner | null;
  handleAddTicketDataToDB: () => void;
  handleFetchDiscount: () => void;
  discountCode: string;
  setDiscountCode: (el: string) => void;
  discountLoading: boolean;
  discount: Discount | null;
  setDiscount: (el: Discount | null) => void;
  disableContinueButton: boolean;
}) {
  return (
    <div className="buy-ticket-container-right">
      <h5>
        <button className="back-btn">
          <i className="bi bi-arrow-left"></i>
        </button>
        <span>Order summary</span>
      </h5>
      <div className="buy-ticket-container-right_order-summary-container">
        {!!selectedTickets.length ? (
          <div className="buy-ticket-container-right_order-summary-container-items">
            {selectedTickets
              .filter((el) => el?.quantity && el?.quantity > 0)
              .map((el, key) => (
                <div
                  className="buy-ticket-container-right_order-summary-container-items-item"
                  key={key}
                >
                  <p>
                    {el.quantity} x {el.name}
                  </p>
                  <p>{el.price > 0 ? `₦${formatMoney(el.price)}` : "Free"}</p>
                </div>
              ))}
          </div>
        ) : null}

        <div className="buy-ticket-container-right_order-summary-container-discount-container">
          <div className="buy-ticket-container-right_order-summary-container-discount">
            <input
              placeholder="Discount Code"
              value={discountCode}
              onChange={(e) => {
                setDiscountCode(e.target.value);
                if (discount != null) setDiscount(null);
              }}
            />
            <button onClick={handleFetchDiscount} disabled={discountLoading}>
              {discountLoading ? (
                <Loading />
              ) : discount ? (
                <i className="bi bi-x-lg"></i>
              ) : (
                "Apply"
              )}
            </button>
          </div>
        </div>

        <div className="buy-ticket-container-right_order-summary-container-total _discount">
          <p>Subtotal</p>
          <p>₦{formatMoney(totalValues?.subtotal ?? 0)}</p>
        </div>
        {totalValues?.discount ? (
          <div className="buy-ticket-container-right_order-summary-container-total _discount">
            <p>Discount</p>
            <p>-₦{formatMoney(totalValues?.discount ?? 0)}</p>
          </div>
        ) : null}
        {totalValues?.charges ? (
          <div className="buy-ticket-container-right_order-summary-container-total _discount">
            <p>Fee</p>
            <p>₦{formatMoney(totalValues?.charges ?? 0)}</p>
          </div>
        ) : null}
        <div className="buy-ticket-container-right_order-summary-container-total">
          <p>Total</p>
          <p>₦{formatMoney(totalValues?.total ?? 0)}</p>
        </div>
      </div>

      <button
        className="buy-ticket-container-right_order-summary-container-continue-btn"
        onClick={handleAddTicketDataToDB}
        disabled={disableContinueButton}
      >
        {loading ? <Loading /> : "Continue"}
      </button>
    </div>
  );
}

export function OrderSummaryMobileView({
  step,
  selectedTickets,
  totalValues,
  handleBookTickets,
  ticketOwners,
  loading,
  primaryTicketOwner,
  handleAddTicketDataToDB,
  handleFetchDiscount,
  discountCode,
  setDiscountCode,
  discountLoading,
  discount,
  setDiscount,
  disableContinueButton,
}: {
  step: number;
  selectedTickets: TicketType[];
  totalValues: { total: number; discount: number; totalQuantity: number };
  handleBookTickets: () => void;
  ticketOwners: TicketOwner[];
  loading: boolean;
  primaryTicketOwner: TicketOwner | null;
  handleAddTicketDataToDB: () => void;
  handleFetchDiscount: () => void;
  discountCode: string;
  setDiscountCode: (el: string) => void;
  discountLoading: boolean;
  discount: Discount | null;
  setDiscount: (el: Discount | null) => void;
  disableContinueButton: boolean;
}) {
  return (
    <div className="buy-ticket-container-mobile-order-summary">
      <OrderSummary
        step={step}
        selectedTickets={selectedTickets}
        totalValues={totalValues}
        handleBookTickets={handleBookTickets}
        ticketOwners={ticketOwners}
        loading={loading}
        primaryTicketOwner={primaryTicketOwner}
        handleAddTicketDataToDB={() => handleAddTicketDataToDB()}
        handleFetchDiscount={handleFetchDiscount}
        discountCode={discountCode}
        setDiscountCode={setDiscountCode}
        discountLoading={discountLoading}
        discount={discount}
        setDiscount={setDiscount}
        disableContinueButton={disableContinueButton}
      />
    </div>
  );
}
